// Student
// Manager
import virtualClassroomManagerEventCreator from 'modules/virtualClassrooms/manager/EventCreator/slices/eventCreator'
import virtualClassroomManagerEventDetails from 'modules/virtualClassrooms/manager/EventDetails/slices/eventDetails'
import virtualClassroomManagerEventDetailsEventEditor from 'modules/virtualClassrooms/manager/EventDetails/slices/eventEditor'
import virtualClassroomManagerEventDetailsSchedules from 'modules/virtualClassrooms/manager/EventDetails/slices/schedules'
import virtualClassroomManagerEventDetailsTasksAndResources from 'modules/virtualClassrooms/manager/EventDetails/slices/tasksAndResources'
import virtualClassroomManagerEventDetailsWaitList from 'modules/virtualClassrooms/manager/EventDetails/slices/waitList'
import virtualClassroomManagerEventList from 'modules/virtualClassrooms/manager/EventList/slices/eventList'
import virtualClassroomManagerSchedulesCreator from 'modules/virtualClassrooms/manager/Schedules/slices/creator'
import virtualClassroomManagerSchedulesEditor from 'modules/virtualClassrooms/manager/Schedules/slices/editor'
import virtualClassroomManagerSchedulesList from 'modules/virtualClassrooms/manager/Schedules/slices/list'
import virtualClassroomStudentEventDetails from 'modules/virtualClassrooms/student/EventDetails/slices/eventDetails'
import virtualClassroomStudentEvents from 'modules/virtualClassrooms/student/Events/slices/events'
import virtualClassroomStudentParticipantScheduleDetails from 'modules/virtualClassrooms/student/ParticipantScheduleDetails/slices/participantScheduleDetails'
import virtualClassroomStudentPresenterScheduleDetails from 'modules/virtualClassrooms/student/PresenterScheduleDetails/slices/presenterScheduleDetails'

const slices = {
  virtualClassroomStudentEvents,
  virtualClassroomStudentEventDetails,
  virtualClassroomStudentParticipantScheduleDetails,
  virtualClassroomStudentPresenterScheduleDetails,
  virtualClassroomManagerEventCreator,
  virtualClassroomManagerEventList,
  virtualClassroomManagerSchedulesList,
  virtualClassroomManagerSchedulesCreator,
  virtualClassroomManagerSchedulesEditor,
  virtualClassroomManagerEventDetails,
  virtualClassroomManagerEventDetailsEventEditor,
  virtualClassroomManagerEventDetailsSchedules,
  virtualClassroomManagerEventDetailsTasksAndResources,
  virtualClassroomManagerEventDetailsWaitList,
}

export default slices
